<div class="skeleton-loading">
  <p-skeleton width="10rem" styleClass="mb-2" />
  <p-skeleton width="8rem" styleClass="mb-2" />
  <p-skeleton width="6rem" styleClass="mb-2" />
  <p-skeleton width="4rem" styleClass="mb-2" />
  <p-skeleton width="2rem" styleClass="mb-2" />
</div>
